import { CredentialLayoutBox, CredentialSearchbar } from '../../../components';
import React, { useState } from 'react';
import { useProfileCredentials } from '../../../hooks';
import './CredentialViewContent.css';
import { ICredential } from '../../../model';
import { Link } from 'react-router-dom';

interface CredentialViewContentProps {
  username: string;
}

export const CredentialViewContent: React.FC<CredentialViewContentProps> = ({
  username
}) => {
  const [
    userCredentials,
    userCredentialsLoaded,
    discoverCredentials,
    discoverCredentialsLoaded,
  ] = useProfileCredentials(username);
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <span>
      <div
        className="ov_panel active"
        data-name="credentials"
        style={{ marginTop: '20px' }}
      >
        <div>
          <div className="form-block-15 w-form">
            <CredentialSearchbar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            ></CredentialSearchbar>
          </div>

         <CredentialLayoutBox
           userCredentials={userCredentials as ICredential[]}
           userCredentialsLoaded={userCredentialsLoaded as boolean}
           discoverCredentials={discoverCredentials as ICredential[]}
           discoverCredentialsLoaded={discoverCredentialsLoaded as boolean}
           searchTerm={searchTerm}
         ></CredentialLayoutBox>

        </div>
      </div>
    </span>
  );
};
